import BlockCta from './cta'

export default BlockCta
